(function () {
  var btn = document.querySelector('.back-to-top');
  if (!btn) return;

  var threshold = 300; // px scrolled before the button appears

  function toggle() {
    if (window.pageYOffset > threshold) {
      btn.classList.add('is-visible');
    } else {
      btn.classList.remove('is-visible');
    }
  }

  window.addEventListener('scroll', toggle, { passive: true });
  toggle();

  btn.addEventListener('click', function () {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
  });
})();
